import React from 'react';
import Entry from '../entry';
import { Text, Flex } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default () => {
  const title = '12. Filter Out Poisoned Sources of Weather Data';
  const flag = '0807198508261964';
  const hints = [
  `[Shiny Upatree Chat] Do you think you could bring this all to a grand conclusion?
Please go into the sleigh shop and see if you can finish this off!
Stop the Tooth Fairy from ruining Santa's sleigh route!`,
  `[Tooth Fairy Chat] I’m the Tooth Fairy, the mastermind behind the plot to destroy the holiday season.
I hate how Santa is so beloved, but only works one day per year!
He has all of the resources of the North Pole and the elves to help him too.
I run a solo operation, toiling year-round collecting deciduous bicuspids and more from children.
But I get nowhere near the gratitude that Santa gets. He needs to share his holiday resources with the rest of us!
But, although you found me, you haven’t foiled my plot!

Santa’s sleigh will NOT be able to find its way.`,
`[Wunorse Openslae Chat] Hey, you know what? We've got a crisis here.
You see, Santa's flight route is planned by a complex set of machine learning algorithms which use available weather data.
All the weather stations are reporting severe weather to Santa's Sleigh. I think someone might be forging intentionally false weather data!
I'm so flummoxed I can't even remember how to login!
Hmm... Maybe the Zeek http.log could help us.
I worry about LFI, XSS, and SQLi in the Zeek log - oh my!
And I'd be shocked if there weren't some shell stuff in there too.
I'll bet if you pick through, you can find some naughty data from naughty hosts and block it in the firewall.
If you find a log entry that definitely looks bad, try pivoting off other unusual attributes in that entry to find more bad IPs.
The sleigh's machine learning device (SRF) needs most of the malicious IPs blocked in order to calculate a good route.
Try not to block many legitimate weather station IPs as that could also cause route calculation failure.
Remember, when looking at JSON data, jq is the tool for you!`,
(<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Wunorse Openslae] </Text><a rel="noopener noreferrer" target="_blank" href='https://www.owasp.org/index.php/Testing_for_Local_File_Inclusion'>LFI</a></Flex>),
(<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Wunorse Openslae] </Text><a rel="noopener noreferrer" target="_blank" href='https://www.owasp.org/index.php/Cross-site_Scripting_(XSS)'>XSS</a></Flex>),
(<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Wunorse Openslae] </Text><a rel="noopener noreferrer" target="_blank" href='https://en.wikipedia.org/wiki/Shellshock_(software_bug)'>Shellshock</a></Flex>),
(<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Wunorse Openslae] </Text><a rel="noopener noreferrer" target="_blank" href='https://www.owasp.org/index.php/SQL_Injection'>SQLi</a></Flex>),
`[Krampus Chat] But there’s still time! Solve the final challenge in your badge by blocking the bad IPs at srf.elfu.org and save the holiday season!`];
  const assignment = 'Use the data supplied in the Zeek JSON logs to identify the IP addresses of attackers poisoning Santa\'s flight mapping software. Block the 100 offending sources of information to guide Santa\'s sleigh through the attack. Submit the Route ID ("RID") success value that you\'re given. For hints on achieving this objective, please visit the Sleigh Shop and talk with Wunorse Openslae.'
  const data = useStaticQuery(graphql`
    query {
      credHint: file(relativePath: { eq: "credHint.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      credentials: file(relativePath: { eq: "credentials.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      loginYas: file(relativePath: { eq: "loginYas.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      calc: file(relativePath: { eq: "calculationSuccess.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code12lfi: file(relativePath: { eq: "code12lfi.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code12pivot: file(relativePath: { eq: "code12pivot.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code12result: file(relativePath: { eq: "code12result.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code12shell: file(relativePath: { eq: "code12shell.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code12sqli: file(relativePath: { eq: "code12sqli.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code12xss: file(relativePath: { eq: "code12xss.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }

    }
  `)
  return (
    <Entry
      title={title}
      hints={hints}
      flag={flag}
      assignment={assignment}
    >
      <Text my={2}>Wunrose mentions that he forgot how to login to the Sleigh Route Finder. Yet from the decripted document that we got from Objective 10 we have a hint about default credentials.</Text>
      <Img fluid={data.credHint.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>The code is closed source, no repo can be found. But the README is accessible through <code>srf.elfu.org</code></Text>
      <Img fluid={data.credentials.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '50vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>And the credentials worked! we logged in and how have a chance to block malicious IPs in the firewall.</Text>
      <Img fluid={data.loginYas.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '50vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text mt={2}>Now it's time to examine Zeek logs for the traces of malicous activity. I used JavaScript to process the log file.</Text>
      <Text mb={2}>First we check log entries for the signs of Cross site scripting</Text>
      <Img fluid={data.code12xss.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '30vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>Wunrose mentioned he was worried about 'shell stuff'. Looking for signs of ShellShock.</Text>
      <Img fluid={data.code12shell.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '25vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>SQLi manifest themselves with 'SELECT' statements in various fields.</Text>
      <Img fluid={data.code12sqli.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '30vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>With Local File Inclusion it's likely that the attacker was trying to get to <code>/etc/passwd</code>, let's check that in logs</Text>
      <Img fluid={data.code12lfi.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '25vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>We have 64 IP addresses that are definitely malicous. Yet we need to come up with 100 according to the Objective description. Wunrose advised us to 'pivot off other unusual attributes' from here. I decided that to pivot off malicious user agents. I found this helpful list online, and checked if those user agents were attributed to our known 'bad IPs'. Then look for all IPs that used the selected known bad user agents.</Text>
      <Img fluid={data.code12pivot.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '50vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>Printing the results:</Text>
      <Img fluid={data.code12result.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>With the list of 104 IP addressed that we blocked, Santa's sleigh can successfully calculate a route!</Text>
      <Img fluid={data.calc.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '50vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
    </Entry>
  )

};
